import {
  PAMVerificationsApi,
  PagePamDocumentQueueSummary,
  PamDocumentContent,
  PamDocumentSummary,
  PamVerificationDetail,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getApi = () => BackOfficeDataServiceAPI.getBackOfficeApi(PAMVerificationsApi)
const getConfig = () => BackOfficeDataServiceAPI.getBackOfficeConfig()

const getVerification = async (pamPlayerId: string): Promise<PamVerificationDetail> => {
  return await getApi().getPamVerification({ customerId: getConfig().customerId, pamPlayerId })
}

const approve = async (pamPlayerId: string, reason: string): Promise<PamVerificationDetail> => {
  return await getApi().approvePamVerification({
    customerId: getConfig().customerId,
    pamPlayerId,
    pamVerificationDecisionBody: { reason },
  })
}

const deny = async (pamPlayerId: string, reason: string): Promise<PamVerificationDetail> => {
  return await getApi().denyPamVerification({
    customerId: getConfig().customerId,
    pamPlayerId,
    pamVerificationDecisionBody: { reason },
  })
}

const unlock = async (pamPlayerId: string, reason: string): Promise<PamVerificationDetail> => {
  return await getApi().unlockPamVerification({
    customerId: getConfig().customerId,
    pamPlayerId,
    pamVerificationDecisionBody: { reason },
  })
}

const listDocuments = async (pamPlayerId: string): Promise<PamDocumentSummary[]> => {
  const { documents } = await getApi().listPamVerificationDocuments({
    customerId: getConfig().customerId,
    pamPlayerId,
  })
  return documents
}

const getDocumentContent = async (
  pamPlayerId: string,
  documentId: string,
): Promise<PamDocumentContent> => {
  return await getApi().getPamVerificationDocumentContent({
    customerId: getConfig().customerId,
    pamPlayerId,
    documentId,
  })
}

const uploadDocument = async (pamPlayerId: string, file: File): Promise<PamDocumentSummary> => {
  const token = await BackOfficeDataServiceAPI.getAccessToken()
  return await getApi().uploadPamVerificationDocument({
    customerId: getConfig().customerId,
    pamPlayerId,
    authorization: `Bearer ${token}`,
    file,
  })
}

const listDocumentQueue = async (params: {
  resultStart: number
  resultEnd: number
}): Promise<PagePamDocumentQueueSummary> => {
  return await getApi().listPamDocumentQueue({ customerId: getConfig().customerId, ...params })
}

const deleteDocument = async (pamPlayerId: string, documentId: string): Promise<void> => {
  return await getApi().deletePamVerificationDocument({
    customerId: getConfig().customerId,
    pamPlayerId,
    documentId,
  })
}

export const PamVerificationServiceAPI = {
  getVerification,
  approve,
  deny,
  unlock,
  listDocuments,
  listDocumentQueue,
  getDocumentContent,
  uploadDocument,
  deleteDocument,
}
